import { Link } from "react-router";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import Header from "@components/Header/Header";
import { useWindowSize } from "@hooks/useWindowSize";
import Content from "@routes/Newsletter/DecodingAsia/components/Content";
import Graphic from "@routes/Newsletter/DecodingAsia/components/Graphic";
import ShareLinks from "@routes/Newsletter/DecodingAsia/components/ShareLinks/ShareLinks";
import { DecodingAsiaPageData } from "@routes/Newsletter/DecodingAsia/utils/types";

/**
 * The main page component for the Decoding Asia newsletter.
 * @figma https://www.figma.com/design/9O7z95a6ncgr3kFoOqJP7Q/BT-GLOBAL?node-id=18655-28678&m=dev
 */
const DecodingAsiaPageContent = ({
  seoFooterData,
}: DecodingAsiaPageData): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <div data-testid="decoding-asia-page-component" className="w-full">
      <Header />

      <Container rootClassName="grid gap-4 grid-cols-1 lg:gap-8 lg:grid-cols-2 py-12">
        <Content />

        <Graphic />

        <>
          {!isScreenLG ? (
            <>
              <p className="mb-0 mt-8 font-poppins text-base font-normal leading-normal text-gray-850">
                Read more about Asia and beyond at The Business Times Global.
                Visit us at{" "}
                <Link
                  to="https://bt.global/"
                  className="font-medium text-verticals-btblue underline"
                  target="_blank"
                >
                  bt.global
                </Link>
                .
              </p>

              <ShareLinks className="border-t border-gray-195 pt-4" />
            </>
          ) : null}
        </>
      </Container>

      <SeoFooter data={seoFooterData} />
    </div>
  );
};

export default DecodingAsiaPageContent;
